import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorRfqList = () => {
  const { t } = useTranslation()
  const [rfqListData, setRfqListData] = useState({})
  const [rfqPages, setRfqPages] = useState({
    currentPage: 1,
    limitRfq: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const { seller } = useSelector((state) => state.seller)

  const rfqList = useCallback(
    (payload, setLoading = () => {}) => {
      let payloadRequest = {
        ...payload,
        keywords: {
          ...payload.keywords,
          store_uid: seller.uid,
        },
      }
      setLoading(true)
      ApiService.jsonRequest('/rfq-quotation/search', payloadRequest, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setRfqPages({
            currentPage: pages.page,
            limitRfq: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          setRfqListData(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [seller.uid, t],
  )

  const rfqView = useCallback(
    (payload, setLoading = () => {}) => {
      const requestPayload = {
        ...payload,
      }
      setLoading(true)
      ApiService.jsonRequest('/rfq-quotation/view', requestPayload, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          let data = response.data
          setRfqListData(data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
      return fetch
    },
    [t],
  )

  return {
    rfqListData,
    rfqList,
    rfqView,
    rfqPages,
    setRfqPages,
  }
}

export default InteractorRfqList
